module.exports = __webpack_public_path__ + "static/img/4bg_17.97afdfc.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/4bg_17.png
// module id = 702
// module chunks = 1